import Icon from 'veui/components/Icon'

Icon.register({
  'question-circle': {
    paths: [
      {
        d: 'M24 48a24 24 0 110-48 24 24 0 010 48zm0-4a20 20 0 100-40 20 20 0 000 40zm2-17.7v4.02a2 2 0 11-4 0v-5.8c0-1.1.9-2 2-2 2.78 0 5-2.14 5-4.76A4.89 4.89 0 0024 13c-2.78 0-5 2.15-5 4.76a2 2 0 11-4 0A8.88 8.88 0 0124 9c4.96 0 9 3.9 9 8.76 0 4.18-3 7.66-7 8.55zM22 36a2 2 0 114 0v1a2 2 0 11-4 0v-1z'
      }
    ],
    width: '48',
    height: '48'
  }
})
